import { render, staticRenderFns } from "./CloseLocation.vue?vue&type=template&id=851f7654&"
import script from "./CloseLocation.vue?vue&type=script&lang=ts&"
export * from "./CloseLocation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports